export default __webpack_public_path__ + "static/media/5.98c68b67.PNG";